export class ErrorResponse {
  errorCode: number;
  errorMessage: string;
  errorLocation: string;
}
